/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import ScrollArea from './js/ScrollArea.jsx';

export default ScrollArea;



// WEBPACK FOOTER //
// ./src/components/ScrollArea/index.js